<template>
	<el-dialog
		:title="title"
		width="70vw"
		v-model="state.dialogTableVisible"
		@close="handleClose"
	>
		<MainTempComp
			ref="mainTempRef"
			v-if="state.dialogTableVisible"
			:searchOption="state.searchOption"
			:handleSearch="handleSearch"
		>
			<template #header>
				<span style="padding-left: 10px"></span>
				<el-button type="primary" @click="handleSearch">查询</el-button>
			</template>
			<template #main>
				<detailed-table
					:tableData="state.tableData"
					:source="state.source"
				></detailed-table>
			</template>
		</MainTempComp>
	</el-dialog>
</template>

<script>
import { reactive, ref, provide, nextTick } from "vue";
import detailedTable from "./detailed-table.vue";
import {
	apiTransactionDetailsList,
	apiTransactionDetailsSumAll,
} from "@/api/requestApis.js";
export default {
	components: { detailedTable },
	props: {
		title: String,
	},
	setup(props) {
		const mainTempRef = ref(null);
		const state = reactive({
			dialogTableVisible: false,
			tableData: [],
			source: 0,
			searchOption: [
				{
					name: "时间",
					type: "datePicker",
					key: "time",
					value: "",
					paramsKey: {
						start_time: "startTime",
						end_time: "endTime",
					},
				},
			],
		});

		const handleSetSource = (val) => {
			state.source = val;
		};

		const hanleToggle = (val) => {
			state.dialogTableVisible = val;
			nextTick(() => {
				if (val) handleSearch();
			});
		};
		const handleClose = () => {};
		const handleSearch = async () => {
			let apiFunc = null;
			if (state.source === 0) {
				apiFunc = apiTransactionDetailsSumAll;
			} else {
				apiFunc = apiTransactionDetailsList;
			}
			const res = await apiFunc({
				size: mainTempRef.value.pageSize,
				current: mainTempRef.value.currentPage,
				...mainTempRef.value.searchParams,
				userType: state.source,
				tType: 1,
			});
			mainTempRef.value.setTotalValue(res && res.total);
			state.tableData = res.list;
		};
		provide("handleSearch", handleSearch);

		return {
			handleClose,
			mainTempRef,
			handleSetSource,
			handleSearch,
			hanleToggle,
			state,
		};
	},
};
</script>

<style  scoped>
</style>
